import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M5.856 20H18.13c.378 0 .787-.667.945-1 .786-3 2.454-9.3 2.832-10.5s-.472-.833-.944-.5l-3.777 2.5L11.993 4 6.8 10.5C6.014 10 4.157 8.8 3.024 8s-1.102 0-.944.5c.787 3 2.36 9.5 2.832 10.5s.944 1 .944 1"
    }, null, -1)
  ])))
}
export default { render: render }